export default {
  每月: "每月",
  季度: "季度",
  全年: "全年",
  計算: "计算",
  新公司計算器: "成立公司费用计算器",
  "2020所得補充稅模擬計算": "2021 - 2022年度所得补充税模拟计算",
  "2021個人職業所得稅計算器": "2023个人职业所得税计算器",
  計算年度: "计算年度",
  "65歲以下": "65岁以下",
  "2021年度剛滿65歲": "2022年度刚满65岁",
  "65歲以上/殘疾人士": "65岁以上/残疾人士",
  "A.每月總收益（包括不課稅收益）": "A. 每月总收益（包括不课税收益）",
  "A.季度總收益（包括不課稅收益）": "A.季度总收益（包括不课税收益） ",
  "A.全年總收益（包括不課稅收益）": "A.全年总收益（包括不课税收益） ",
  "B.不屬課稅收益": "B.不属课税收益",
  "C.固定扣除，相當於對B項扣減後之工作收益之25%":
    "C.固定扣除，相当于对B项扣减后之工作收益之 25%",
  "D.每月可課稅收益": "D.每月可课税收益(A-B-C)",
  "D.季度可課稅收益": "D.季度可课税收益(A-B-C)",
  "D.全年可課稅收益": "D.全年可课税收益(A-B-C)",
  出生年份: "出生年份",
  時間: "时间",
  註冊資本: "注册资本",
  由: "由",
  至: "至",
  稅率: "税率",
  可課稅收益: "可课税收益",
  該級可課稅收益: "该级可课税收益",
  該級稅款: "该级税款",
  累計稅款: "累计税款",
  根據法定稅率計出之每月稅款: "E.根据法定税率计出之每月税款",
  根據法定稅率計出之季度稅款: "E.根据法定税率计出之季度税款",
  根據法定稅率計出之全年稅款: "E.根据法定税率计出之全年税款",
  "根據有關年度財政預算案對職業稅稅額之30%扣減優惠":
    "F.根据有关年度财政预算案对职业税税额之30%扣减优惠",
  每月應繳職業稅稅款: "G.每月应缴职业税税款",
  季度應繳職業稅稅款: "G.季度应缴职业税税款",
  全年應繳職業稅稅款: "G.全年应缴职业税税款",
  "(1)計算結果僅供參考。而確定性可課稅金額以稅務當局所作之評定為準。":
    "(1)计算结果仅供参考。而确定性可课税金额以税务当局所作之评定为准。",
  "(2)不足一元的部分，作一元計。": "(2)不足一元的部分，作一元計。",
  "(3)不足一元的部分，作一元計。": "(3)不足一元的部分，作一元計。",
  "B.應繳所得補充稅稅款": "B.应缴所得补充税税款",
  "A. 年度之可課稅收益": "A. 年度之可课税收益",
  "(2)僅適用於2020年度取得的收益。": "(2)仅适用于2020年度取得的收益。",
  "Must greater than or equal to 25000.": "输入金额必须大于25000",

  simpleVueValidator_required: "必填",
  simpleVueValidator_integer: "输入值需为整数",
  simpleVueValidator_greaterThenZero: "相关数字不能为负数",
  simpleVueValidator_over_three_million: "超过300万",
  stamp_duty_transfer: "印花税（财产之移转）模拟计算",
  bought_value: "购买价值",
  mop: "澳门币",
  house_record_value: "房屋记录价值",
  please_input_int_amt: "请输入整数金额。",
  confirm_transfer: "确定转移",
  confirm_middle_transfer: "确定转移(曾作出中间移转)",
  from: "由",
  till: "至",
  tax_rate: "税率",
  tax_amt: "可课税金额",
  level_tax: "该级税款",
  sub_tax_amt: "累计税款",
  property_transfer_stamp_duty: "财产转移印花税",
  voucher_stamp_duty: "凭单印花税",
  total_tax_amt: "应缴税款总额",
  calculate: "计算",
  ahead_1: "",
  ahead_2: "以上",
  remark_1: "计算结果仅供参考。而确定性可课税金额以税务当局所作之评定为准。",
  remark_2: "不足一元的部分, 作一元计。",
  remark_3: "对出租房屋可课税收益适用的税率为百分之八。",
  remark_3_1: "对非出租房屋可课税收益适用的税率为百分之六。",
  transfer_real_estate_stamp_duty: "关于移转不动产的特别印花税之模拟计算",
  sale_value: "出售价值",
  calculate_transfer_stamp_duty_from_one_year:
    "于结算财产移转印花税之日起计一年内作出移转",
  calculate_transfer_stamp_duty_from_two_year:
    "于结算财产移转印花税之日起计第二年内作出移转",
  house_tax_calculator: "2020 - 2022年度市区房屋税之模拟计算",
  house_for_rent: "出租房屋",
  house_not_for_rent: "非出租房屋",
  if_macau_id_holder: "业主是否持有澳门特别行政区居民身份证?",
  please_select: "请选择",
  yes: "是",
  no: "否",
  real_estate_type: "不动产种类",
  residential: "住宅",
  business: "酒店及同类活动、写字楼、商业及工业用途",
  other: "其他",
  rent_value: "年租金",
  M7_manage_value: "申报于「房屋税 - 维修及管理费用 M/7」之金额 : ",
  tax_revenue: "可课税收益",
  tax: "税款",
  except_house_tax: "根据有关年度财政预算对市区房屋税之豁免",
  rent_stamp_duty: "租约印花税",
  expect_rent_value: "估定年租值",
  company_tax_calculate: "企业所得税简要计算表",
  company_type: "企业类型",
  normal_company: "普通企业",
  non_resident_company: "非居民企业",
  high_tech_company: "符合条件在粤澳资企业及高新技术企业",
  low_profit_company: "小型微利企业",
  expect_tax_value: "应纳税所得额",
  expect_personal_tax: "应纳个人所得税",
  personal_tax: "个人所得税",
  company_tax: "企业所得税",
  over_one_million: "<=1,000,000部分",
  between_one_million_and_three_million: "1,000,000<应纳税所得额<=3,000,000",
  needed_tax: "所得税",
  remark: "备注: ",
  remark_6:
    "根据《中华人民共和国企业所得税法》规定：非居民企业在中国境内未设立机构、场所的，或者虽设立机构、场所但取得的所得与其所设机构、场所没有实际联系的，应当就其来源于中国境内的所得缴纳企业所得税。",
  remark_7:
    "根据《关于实施小型微利企业普惠性所得税减免政策有关问题的公告》规定：小型微利企业是指从事国家非限制和禁止行业，且同时符合年度应纳税所得额",
  remark_7_1: "不超过300万元",
  remark_7_2: "、从业人数",
  remark_7_3: "不超过300人",
  remark_7_4: "、资产总额",
  remark_7_5: "不超过5000万元",
  remark_7_6: "等三个条件的企业。",
  remark_8: "关于小型微利企业的所得税优惠政策目前有效期至",
  remark_8_1: "2021年12月31日",
  remark_8_2: "。",
  disclaimer1: "以上计算表之应纳税所得额为已经经过纳税调整后",
  disclaimer2:
    "上述计算表不反映当局和执业注册会计单位之实际课税/评税行为，仅供参考",
  personal_tax_calculate: "个人所得税计算表",
  personal_tax_per_year: "个人所得税计算表(居民个人综合所得适用-按年)",
  personal_tax_per_year_non_chinese:
    "个人所得税计算表(非居民个人综合所得适用-按月/按次)",
  personal_tax_company: "个人所得税计算表(经营所得适用)",
  personal_tax_other:
    "个人所得税计算表(利息、股息、红利所得,财产租赁所得,财产转让所得和偶然所得适用)",
  remark_personal_per_year_1:
    "根据《中华人民共和国企业所得税法》规定：居民个人综合所得包括工资、薪金所得、劳务报酬所得、稿酬所得、特许权使用费所得。劳务报酬所得、稿酬所得、特许权使用费所得以收入减除百分之二十的费用后的余额为收入额。稿酬所得的收入额减按百分之七十计算。",
  remark_personal_1:
    "在中国境内有住所，或者无住所而一个纳税年度内在中国境内居住累计满一百八十三天的个人，为居民个人。居民个人从中国境内和境外取得的所得，依规定缴纳个人所得税；在中国境内无住所又不居住，或者无住所而一个纳税年度内在中国境内居住累计不满一百八十三天的个人，为非居民个人。非居民个人从中国境内取得的所得，依法规定缴纳个人所得税。",
  remark_personal_non_chinese:
    "根据《中华人民共和国企业所得税法》规定：非居民个人取得工资、薪金所得、劳务报酬所得、稿酬所得、特许权使用费所得，按月或者按次分项计算个人所得税。劳务报酬所得、稿酬所得、特许权使用费所得以收入减除百分之二十的费用后的余额为收入额。稿酬所得的收入额减按百分之七十计算。",
  remark_personal_disclaimer: "本计算未考虑扣除，计算结果仅供参考。",
  revenue_year: "收入(年度总额)",
  cost_year: "成本(年度总额)",
  expense_year: "费用(年度总额)",
  loss_year: "损失(年度总额)",
  CEL_year: "成本、费用、损失(年度总额)",
  remark_personal_company:
    "个体工商户的生产、经营所得和对企事业单位的承包经营、承租经营所得适用。",
  unit_RMB: "单位：人民币",
  dividends: "利息、股息、红利所得",
  property_for_rent: "财产租赁所得",
  property_for_transfer: "财产转让所得",
  property_transfer_revenue: "财产转让收入",
  property_origin_amount: "财产原值",
  reasonable_expense: "合理费用",
  incident_income: "偶然所得",
  total: "总计",
  disclaimer_GBP_1:
    "未提及之扣除、免征、减征个人所得税的详细规定请参照相关政策文件。",
  disclaimer_GBP_2:
    "本计算器计算结果仅供参考。具体申报纳税义务，请依照国家税收法律、法规、规章及规范性文件的规定执行。",
  disclaimer_GBP_3:
    "上述计算表不反映当局和执业注册会计单位之实际课税/评税行为，仅供参考。",
  total_income_amount: "综合所得金额",
  salary_income: "工资、薪金所得",
  remuneration_income: "劳务报酬所得",
  manuscript_income: "稿酬所得",
  royalties_income: "特许权使用费所得",
  social_insurance: "各项社会保险金",
  deductions: "专项附加扣除及其他依法确定的扣除",
  per_month: "每月",
  per_time: "每次",
  tax_amount: "应缴税款",
  register_capital_limit_25000: "注册资本下限为澳门元MOP$25,000.00，不设上限",
  notarization_fee: "公证手续费",
  notarial_stamp_duty_2021: "公证书印花税(2021年3月31日生效)",
  registration_certificate_fee: "商业名称可予登记证明费用(单次)定额MOP 65",
  company_registration: "公司登记",
  main_cost_setup_company: "成立公司主要费用合共约",
  simpleVueValidator_can_divided_by_100: "必须是100的倍数",
  simpleVueValidator_only_year: "请输入出生日期，格式必须为年/月/日",
  above: "以上",
  incomeTax_discount:
    "根据有关年度财政预算案对所得补充税税额之扣减优惠 （税款扣减额为三十万元）",
  incomeTax_allYear: "全年应缴所得补充税税款（B – C）",
};
